import React from 'react';
import PropTypes from 'prop-types';
import Number from '../../Number';

AuctionHeaderNumberOfLots.propTypes = {
    numberOfLots: PropTypes.number.isRequired,
    postfix: PropTypes.node,
};

AuctionHeaderNumberOfLots.defaultProps = {
    postfix: null,
};

function AuctionHeaderNumberOfLots(props) {
    const {
        numberOfLots,
        postfix,
    } = props;
    return (
        <div className="auction-header--number-of-lots">
            <Number value={numberOfLots} />{postfix && <>&nbsp;{postfix}</>}
        </div>
    );
}

export default AuctionHeaderNumberOfLots;
